import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

import { Reader } from "@PublicationReader/views/Reader";
import { ReaderContextProvider } from "@PublicationReader/context";
import { PublicationI } from "@PublicationReader/@types/Publication";

import commonSV from "@PublicationReader/translations/sv/common.json";
import commonEn from "@PublicationReader/translations/en/common.json";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "sv",
  resources: {
    sv: {
      common: commonSV,
    },
    en: {
      common: commonEn,
    },
  },
});

export interface AppProps {
  publication: PublicationI;
  apiDownloadUrl: string;
}

const App = ({ publication, apiDownloadUrl }: AppProps) => {
  return (
    <div className="pubr">
      <ReaderContextProvider>
        <I18nextProvider i18n={i18next}>
          <Reader publication={publication} apiDownloadUrl={apiDownloadUrl} />
        </I18nextProvider>
      </ReaderContextProvider>
    </div>
  );
};

export default App;
